import React from 'react';
import {connect} from 'react-redux';
import PackageWrapper from './PackageWrapper';

class MyPackages extends React.Component {
    render() {
        const {packages, pending} = this.props;
        return <PackageWrapper wrapperClassName="section-my-packages" title="Моите Пакети" className="main" packages={packages} pending={pending} />
    }
}

const mapStateToProps = (state) => {
    return {
        packages: state.packages.packages.filter(pack => pack.userPackageId !== undefined),
        pending: state.packages.userPackagesPending
    }
};

const mapDispatchToProps = (dispatch) => { return {dispatch} };

export default connect(mapStateToProps, mapDispatchToProps)(MyPackages);


// WEBPACK FOOTER //
// ./src/components/Containers/UserPackages.js